module.exports = __webpack_public_path__ + "img/conversation.f2773ed7.png";